import React from "react";
import {
  WrenchScrewdriverIcon,
  ArrowPathIcon,
  ArrowLeftIcon,
  ClockIcon,
  BuildingOfficeIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

const UnderConstruction = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-base-200 via-base-100 to-base-200 flex items-center justify-center p-4">
      <div className="card w-full max-w-xl bg-white backdrop-blur-lg bg-opacity-90 shadow-2xl">
        <div className="card-body items-center text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <WrenchScrewdriverIcon className="w-64 h-64 absolute -right-20 -top-20 transform rotate-12" />
            <BuildingOfficeIcon className="w-64 h-64 absolute -left-20 -bottom-20 transform -rotate-12" />
          </div>
          <div className="relative z-10">
            <div className="relative mb-8">
              <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                <WrenchScrewdriverIcon className="w-12 h-12 text-primary animate-[spin_3s_ease-in-out_infinite]" />
              </div>
              <ExclamationTriangleIcon className="w-8 h-8 text-warning absolute -right-4 top-0 animate-bounce" />
            </div>

            <h2 className="font-bold text-4xl mb-2 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Đang Xây Dựng
            </h2>

            <div className="flex items-center justify-center gap-2 mb-6">
              <ClockIcon className="w-5 h-5 text-secondary" />
              <p className="text-base-content/70 font-medium">
                Trang đang được phát triển
              </p>
            </div>
            <div className="divider before:bg-primary/20 after:bg-primary/20"></div>
            <div className="prose prose-sm max-w-none mb-8">
              <p className="text-base-content/80">
                Chúng tôi đang nỗ lực xây dựng một trải nghiệm tuyệt vời. Trang
                web sẽ sớm hoàn thiện với nhiều tính năng hấp dẫn.
              </p>
              <p className="text-base-content/70">Xin vui lòng quay lại sau!</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <button
                onClick={() => window.history.back()}
                className="btn btn-primary gap-2 hover:scale-105 transition-transform"
              >
                <ArrowLeftIcon className="w-5 h-5" />
                Quay lại
              </button>
              <button
                onClick={() => window.location.reload()}
                className="btn btn-ghost gap-2 hover:bg-base-200 transition-colors"
              >
                <ArrowPathIcon className="w-5 h-5" />
                Tải lại trang
              </button>
            </div>
            <div className="w-64 h-2 bg-base-200 rounded-full overflow-hidden mx-auto">
              <div className="h-full bg-primary rounded-full animate-[loading_2s_ease-in-out_infinite]"></div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes loading {
          0% {
            width: 0%;
          }
          50% {
            width: 70%;
          }
          80% {
            width: 80%;
          }
          95% {
            width: 90%;
          }
          100% {
            width: 95%;
          }
        }
      `}</style>
    </div>
  );
};

export default UnderConstruction;
